import Text17_morph from './Text17_morph'
export default Text17_morph
